<template>
  <div class="day_box">
    <div class="title">{{title}}</div>
    <div class="day">
        <div class="day_txt" v-for="item in list"  @click="addDay(item.value)">
            <span :class="dayNum === item.value ? 'color' : ''">
                {{ item.text }}
            </span>
        </div>
    </div>
  </div>
</template>

<script>
export default {
    props:{
        title:{
            type:String,
            default:''
        },
        dayNum:{
            type:Number,
            default:30
        }
    },
  data() {
    return {
        list:[
            {text:'近7天',value:7},
            {text:'近15天',value:15},
            {text:'近30天',value:30},
            {text:'近90天',value:90},
        ]
    }
  },
  methods: {
    addDay(value) {
        this.$emit('addDay',value)
    }
  }
}
</script>

<style scoped lang="less">
.day_box {
    height: 40px;
    background-color: #fff;
    display: flex;
    justify-content: space-between;
    padding: 0 12px;
    .title {
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        font-weight: 500;
        color:#141B27;
    }
    .day {
        display: flex;
        .color {
            color: #2877FF;
        }
        .day_txt {
            display: flex;
            align-items: center;
            color:#8E9AAE;
            padding: 0 4px;
        }
    }
}
</style>
